import { TICKS_PER_BAR, TICKS_PER_BEAT } from '../../shared/tempo';
import type { ClassDefinition, UpgradeDefinition } from '../types';

export interface BallAttack {
  kind: 'ball';
  damage: number;
  cooldownTicks: number;
  speed: number;
  radius: number;
  rangeTicks: number;
  bounces: number;
  range: number;
  returnSpeed: number;
  elan: { fillBars: number; drainBeats: number; damageMul: number; bounces: number };
}

export interface SprintEffect {
  kind: 'sprint';
  beats: number;
  speedMul: number;
  damage: number;
  knockBeats: number;
}

export const SPORTIF: ClassDefinition = {
  id: 'sportif',
  name: 'Le Sportif',
  role: 'Frappe son ballon de bad vibe en bad vibe, et court pour frapper plus fort.',
  color: '#5aa2ff',
  maxHp: 140,
  speed: 8.6,
  radius: 14,
  pickupRadius: 100,
  attack: {
    kind: 'ball',
    damage: 18,
    cooldownTicks: 2 * TICKS_PER_BEAT,
    speed: 20,
    radius: 6,
    rangeTicks: 13,
    bounces: 3,
    range: 180,
    returnSpeed: 16,
    elan: { fillBars: 2, drainBeats: 2, damageMul: 1.5, bounces: 1 },
  },
  skill: {
    id: 'sprint-final',
    name: 'Sprint final',
    description: 'Tu sprintes, l’Élan à fond, et renverses toutes les bad vibes que tu traverses.',
    cooldownTicks: 2 * TICKS_PER_BAR,
    effect: { kind: 'sprint', beats: 4, speedMul: 1.5, damage: 24, knockBeats: 1 },
  },
  gauge: { kind: 'elan', name: 'Élan', max: 1 },
  affinityWeaponIds: ['frisbee'],
  excludedWeaponIds: ['monocycle'],
};

export const SPORTIF_UPGRADES: readonly UpgradeDefinition[] = [
  {
    id: 'frappe-enroulee',
    name: 'Frappe enroulée',
    description: 'Ton ballon fait un rebond de plus.',
    family: 'class',
    classId: 'sportif',
    modifiers: [{ stat: 'pierceAdd', add: 1 }],
    rarities: {
      rare: {
        description: 'Ton ballon fait deux rebonds de plus.',
        modifiers: [{ stat: 'pierceAdd', add: 2 }],
      },
      legendary: {
        description: 'Ton ballon fait trois rebonds de plus.',
        modifiers: [{ stat: 'pierceAdd', add: 3 }],
      },
    },
    maxStacks: 2,
  },
  {
    id: 'frappe-de-mule',
    name: 'Frappe de mule',
    description: 'Ton ballon file plus vite et plus loin.',
    family: 'class',
    classId: 'sportif',
    modifiers: [{ stat: 'projectileSpeedMul', mul: 1.3 }],
    rarities: {
      rare: {
        description: 'Ton ballon file nettement plus vite et plus loin.',
        modifiers: [{ stat: 'projectileSpeedMul', mul: 1.6 }],
      },
      legendary: {
        description: 'Ton ballon file deux fois plus vite et plus loin.',
        modifiers: [{ stat: 'projectileSpeedMul', mul: 2 }],
      },
    },
    maxStacks: 2,
  },
  {
    id: 'coup-d-epaule',
    name: 'Coup d’épaule',
    description: 'Ton sprint final renverse plus fort.',
    family: 'class',
    classId: 'sportif',
    modifiers: [{ stat: 'skillPowerMul', mul: 1.55 }],
    rarities: {
      rare: {
        description: 'Ton sprint final renverse deux fois plus fort.',
        modifiers: [{ stat: 'skillPowerMul', mul: 2.25 }],
      },
      legendary: {
        description: 'Ton sprint final renverse trois fois plus fort.',
        modifiers: [{ stat: 'skillPowerMul', mul: 3 }],
      },
    },
    maxStacks: 2,
  },
  {
    id: 'recuperation',
    name: 'Récupération',
    description: 'Ton sprint final revient plus vite.',
    family: 'class',
    classId: 'sportif',
    modifiers: [{ stat: 'skillCooldownMul', mul: 0.64 }],
    rarities: {
      rare: {
        description: 'Ton sprint final revient bien plus vite.',
        modifiers: [{ stat: 'skillCooldownMul', mul: 0.36 }],
      },
      legendary: {
        description: 'Ton sprint final revient presque aussitôt.',
        modifiers: [{ stat: 'skillCooldownMul', mul: 0.16 }],
      },
    },
    maxStacks: 2,
  },
];
